<app-ad-landingpage-top-bar></app-ad-landingpage-top-bar>

<!-- <div class="ui-g-12" style="background-color: lightblue; height: auto; display: flex; flex-wrap: wrap; align-items: center;">
    <div class="ui-g-2"></div>
    <div class="ui-g-1 ui-md-1 ui-lg-1 ui-sm-12" style="order: 1; flex: 1; margin-bottom: 1rem;">
      <img src="../../../../assets/images/ad_landing_page_assets/Group 14924.png" style="max-height: 100px; max-width: 100%;">
    </div>
    <div class="ui-g-6 ui-md-6 ui-lg-6 ui-sm-12" style="order: 2; flex: 2; padding: 2%;">
      <p>More Savings and more benefits with our membership plans</p>
      <div class="ui-g" style="display: flex; flex-direction: row; align-items: center;">
        <img src="../../../../assets/images/ad_landing_page_assets/Group 14925.png" style="height: 30px; width: auto; max-width: 100%; margin-right: 15px;">
        <p>Starting from ₹199, <span class="egd-color"><b>Join now</b></span></p>
      </div>
    </div>
</div> -->

<div class="ui-g-12 container-plan" *ngIf="!this.is_uk_country">
  <div class="ui-sm-2"></div>
  <div class="ui-g-4 ui-sm-12" style="display: flex; flex-wrap: wrap; justify-content: right">
    <img src="../../../../assets/images/ad_landing_page_assets/Group 14924.png"
      style="max-width: 400px; height: auto" />
  </div>
  <div class="ui-g-12 ui-sm-12 plan-text">
    <div class="t-plan" style="padding-bottom: 5px">
      More savings and more benefits with our membership plans
    </div>
    <div class="container-member-button">
      <div class="member-button">
        <!-- <button class="member-t-plan">Membership Plan</button>
                <span class="arrow"></span> -->
        <img src="../../../../assets/images/ad_landing_page_assets/Group 14925.png" class="member-arrow"
          style="cursor: pointer" [routerLink]="['../', 'consult-doctor']" />
      </div>
      <p class="t-plan-start" style="margin-left: 10px">
        Starting from <span class="notranslate"><span *ngIf="!this.is_uk_country">₹199</span><span
            *ngIf="this.is_uk_country">£150</span></span>,
        <b class="t-plan"><a (click)="gotomembership()">Join Now!</a></b>
      </p>
    </div>
  </div>
</div>

<div class="ui-g-12">
  <div class="ui-g-2"></div>
  <div class="ui-g-9">
    <div style="display: flex;align-items: first baseline;justify-content: end">
      <div style="font-size: 17px;font-weight: bold;">
        <p>Choose Language : </p>
      </div>
      <select class="notranslate customize-dropdown" [(ngModel)]="selectedLanguage" (change)="translatePage($event)"
        style="border: 1px solid black;padding:4px;margin-left: 10px;border-radius: 3px;">
        <option *ngFor="let option of languageOptions" [value]="option.code">
          {{ option.name }}
        </option>
      </select>
    </div>
  </div>
  <div class="ui-g-1"></div>
</div>

<div class="ui-g-12">
  <div class="ui-g">
    <div class="ui-g-12 consult_intro">
      <div class="ui-g-6 ui-sm-12" style="text-align: center">
        <p class="top_statement" style="font-weight:bold;margin-top:2%;">
          <b>Skip Travel Time, <br />
            Book Online health <br />consultation <br /></b>
        </p>
        <p class="middle_statement">
          Connect with Doctor Within 30 minutes, <br />
          Starting at Just
          <span style="font-weight: bold; color: black" class="notranslate"><span
              *ngIf="this.is_uk_country">£150</span><span *ngIf="!this.is_uk_country">₹199</span>.</span><br />
        </p>
        <button pButton type="button" label="Book Consultation" [routerLink]="['../', 'consult-doctor']"
          class="btn commonhealthbtn__book notranslate"></button>
        <div class="ui-g-12" style="font-weight: bold" *ngIf="!this.is_uk_country">

          <div class="ui-g-4">
            <p class="last_statement" style="border-right: 2px solid gray">
              <span class="egd-color notranslate">400+</span><br />Doctors
            </p>
          </div>
          <div class="ui-g-4">
            <p class="last_statement" style="border-right: 2px solid gray">
              <span class="egd-color notranslate">many</span><br />Services
            </p>
          </div>
          <div class="ui-g-4">
            <p class="last_statement">
              <span class="egd-color notranslate">8+</span><br />Countries
            </p>
          </div>
        </div>
      </div>
      <div class="ui-g-5 ui-sm-12 consult_img image-visible">
        <img src="../../../../assets/images/ad_landing_page_assets/image main page.png" alt="consultation image" />
      </div>
    </div>
  </div>
</div>

<div class="ui-g-12"></div>
<div class="ui-g-12"></div>
<h2 class="heading2 titled">Common Health Issues</h2>
<div class="ui-g-12"></div>
<div>
  <div class="ui-g-12" style="background-color: gainsboro">
    <div class="content">
      <p-carousel [value]="commonissues" [numVisible]="4" [numScroll]="1" [responsiveOptions]="responsiveOptions"
        data-margin="10" [circular]="true" [autoplayInterval]="3000">
        <ng-template let-issue pTemplate="item">
          <div class="issue-card">
            <p-card>
              <img src="{{ issue.health_issue_image }}" alt="{{ issue.title }}" style="width: 100%" />
              <div style="height: 50px; display: flex; align-items: center">
                <h5>{{ issue.title }}</h5>
              </div>
              <p class="egd-color" style="cursor: pointer; font-weight: bold" (touchend)="consultNow(issue.id)"
                (click)="consultNow(issue.id)">
                Consult Now
              </p>
              <!-- <button pButton type="button" label="Consult Now" routerLink="../consult-doctor"
                class="dashbutton cardmargin book-button" style="background-color: white; color: blue; border: none"></button>
              routerLink="/consult-doctor"
                [queryParams]="{ common_health_id: issue.id }" -->
            </p-card>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>
</div>

<div class="ui-g-12" *ngIf="!this.is_uk_country"></div>
<div class="ui-g-12" *ngIf="!this.is_uk_country"></div>
<p class="heading2 titled" *ngIf="!this.is_uk_country">Offers</p>
<div class="ui-g-12" *ngIf="!this.is_uk_country">
  <ng-container>
    <div class="ui-g-12">
      <div class="ui-g-1"></div>
      <div class="ui-g-5 ui-sm-12" style="margin-right: 20px">
        <img src="../../../../assets/images/ad_landing_page_assets/Group 14922.png" alt="spl_ofr_lab"
          style="width: 100%; height: auto; cursor: pointer" [routerLink]="['../', this.slug, 'consult-doctor']" />
      </div>

      <div class="ui-g-5 ui-sm-12">
        <img src="../../../../assets/images/ad_landing_page_assets/Group 14923.png" alt="spl_ofr_days"
          style="width: 100%; height: auto; cursor: pointer" [routerLink]="['../', this.slug, 'consult-doctor']" />
      </div>
    </div>
  </ng-container>
</div>

<div class="ui-g-12" *ngIf="!this.is_uk_country"></div>
<div class="ui-g-12" *ngIf="!this.is_uk_country"></div>
<p class="heading2 titled" *ngIf="!this.is_uk_country">Additional Offerings</p>
<br />
<div class="ui-g-12" style="background-color: gainsboro" *ngIf="!this.is_uk_country">
  <div class="ui-g">
    <ng-container>
      <div class="ui-g-12 image-row">
        <div class="ui-lg-3 ui-sm-12">
          <div class="card11_add">
            <div class="card-title cd_title">
              <div class="heading">
                <p>Health Care Packages</p>
              </div>

              <p class="under_heading">
                Parents travelling to USA?<br />
                Worried about their medical needs?
              </p>
            </div>
            <img src="../../../../assets/images/ad_landing_page_assets/Parents_travelling.png"
              (click)="gotomembership()" class="commonhealthimg" alt="Card image" />
            <div class="ui-g-12 description">
              <div class="title_diet" style="float:left">Pricing starting from <span class="notranslate">₹9999.00</span>
              </div>
              <div style="float:right;display: flex;align-items: center;justify-content: center;">
                <button pButton type="button" label=" Know more >" style="margin-left: auto" (click)="gotomembership()"
                  class="dashbutton_book commonhealthbtn_diet"></button>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-lg-3 ui-sm-12">
          <div class="card11_add">
            <div class="card-title cd_title">
              <div class="heading">
                <p>eGlobal Pharmacy</p>
              </div>
              <p class="under_heading">
                Now get your medicine delivered at your doorstep.<br />
                Partnered with Sheger Pharmacy.
              </p>
            </div>

            <img src="../../../../assets/images/ad_landing_page_assets/Pharmacy_landingpage.png"
              [routerLink]="['/', this.slug, 'user', 'login', 'patient']" class="commonhealthimg" alt="Card image" />

            <div class=" ui-g-12 description">
              <div style="float: right;margin-left: auto;display: flex;align-items: center;justify-content: center;">
                <button pButton type="button" label="Know more >" style="margin-left: auto;padding:0"
                  class="dashbutton_book commonhealthbtn_diet"
                  [routerLink]="['/', this.slug, 'user', 'login', 'patient']"></button>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-lg-3 ui-sm-12">
          <div class="card11_add">
            <div class="card-title cd_title">
              <div class="heading">
                <p>Health Packages for Employers and Employees</p>
              </div>
              <p class="under_heading">
                Are you looking for affordable and comprehensive healthcare for
                your employees?
              </p>
            </div>

            <img src="../../../../assets/images/ad_landing_page_assets/Employeer_Employee.png"
              [routerLink]="['../', this.slug, 'membership-plan']" class="commonhealthimg" alt="Card image" />

            <div class="description" style="
                align-items: right;
                justify-content: right;
                margin-left: auto;
              ">
              <p class="title_diet" *ngIf="!this.is_uk_country">Get started for FREE</p>

              <button pButton type="button" label=" Contact Us >" href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL', 'contactus', '_self')"
                class="dashbutton_book commonhealthbtn_diet"></button>
            </div>
          </div>
        </div>

        <div class="ui-lg-3 ui-sm-12" *ngIf="!this.is_uk_country">
          <div class="card11_add">
            <div class="card-title cd_title">
              <div class="heading">
                <p>Diet Programs</p>
              </div>
              <p class="under_heading">
                We Holistic Nutritionists help you reverse chronic diseases
                like:
              </p>
            </div>

            <img src="../../../../assets/images/ad_landing_page_assets/Free_Diet_Plan.png" class="commonhealthimg"
              alt="Card image" (click)="gotodiet()" />

            <div class="ui-g-12 description">
              <div class="title_diet" style="float: left;"> Get started for FREE</div>
              <div style="float: right;display: flex;align-items: center;justify-content: center;">
                <button pButton type="button" label=" Know more >" (click)="gotodiet()"
                  class="dashbutton_book commonhealthbtn_diet" style="margin-left: auto;padding:0"></button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="ui-g-12"></div>
<div class="ui-g-12" style="margin: 0; padding: 0">
  <app-home-footer></app-home-footer>
</div>

<!-- <div class="text-align-center">
    <button pButton type="button" (click)="display = !display; focusfield.scrollIntoView()"
        [label]="display ? 'Show Less' : 'Load More'" class="dashbutton cardmargin commonhealthbtn"
        role="button"></button>
</div> -->

<!-- <div class="background-image">
    <div class="overlay">
        <p class="text">Save your Travel time! <br> Talk to a doctor from comfort of your home. </p>
        <p class="text1">Connect with a Doctor Within 30 minutes, Starting at Just <b>449 Rs.</b></p>
        <button class="btn"> <a class="btna" href="https://portal.eglobaldoctors.com/user/register/patient">Book
            Consultation</a></button>

    </div>
</div>

<div class="ui-g-12">
    <div class="container2">
        <a href="https://portal.eglobaldoctors.com/user/register/patient"><img class="Thursday-offer" src="../../../../assets/images/ad_landing_page_assets/Thursday_offer banner_AD.png" alt="" srcset="">
       </a>
    </div>
</div>

<div class="ui-g-12">
    <ng-container>
        <div class="ui-g ht_ig">
            <div class="left-con" style="padding-left: 40px;padding-top: 25px;">
                <img src="../../../../assets/images/ad_landing_page_assets/tenpoff.png" style="height:95px;width:150px">
                <br><br>
                <p class="uema" style="font-weight: bold;">Unlock Expert Medical Advice</p>
                <p class="des"><b>Save 10% on Your First <br> Consultation with eGlobalDoctors!</b></p>
                <div class="btm-cnt">
                    <p class="btm-txt">Also available on </p>
                    <div class="play_store">
                        <img src="../../../../assets/images/ad_landing_page_assets/Group 78.png"
                            style="height:30px;width:200px">
                    </div>

                </div>
            </div>
            <div class="threemob">
                <img src="../../../../assets/images/ad_landing_page_assets/Offer_banner_graphics.png" alt="img">
            </div>
        </div>
        <div class="ui-g-12">
            <div class="container1">
                <div class="sec-left">
                    <p class="sec-left-cnt"><b>Discover eGlobalDoctors:<br>Your Gateway to Expert<br>Healthcare
                            Services</b>
                    </p>
                    <button class="btn2"><a style="color: white;" href="https://www.eglobaldoctors.com/">Know More</a></button>
                </div>
                <div class="sec-right">
                    <div class="feed">
                        <div class="text-container1">
                            Best Choice for Budget- <br> Friendly consultation
                        </div>
                        <div class="image-1">
                            <img class="arr1" src="../../../../assets/images/ad_landing_page_assets/arrow1.png"
                                style="height: 60px; width: 40px;">
                            <img class="image1"
                                src="../../../../assets/images/ad_landing_page_assets/Intersection 46.png"
                                style="height: 150px; width: 150px;">
                        </div>
                    </div>
                    <div class="feed">
                        <div class="image-o">
                            <img class="image2"
                                src="../../../../assets/images/ad_landing_page_assets/Intersection 48.png"
                                style="height: 180px; width: 180px;">
                            <img class="arr2" src="../../../../assets/images/ad_landing_page_assets/arrow2.png"
                                style="height: 60px; width: 60px;">
                        </div>
                        <div class="text-container2">
                            Fast and affordable service
                        </div>
                    </div>
                    <div class="feed">
                        <div class="text-container3">
                            Uncompromising Quality
                        </div>
                        <div class="image-2">
                            <img class="arrow4" src="../../../../assets/images/ad_landing_page_assets/arrow4.png"
                                style="height: 40px; width: 60px; 
                            ">
                            <img class="arr3" src="../../../../assets/images/ad_landing_page_assets/Intersection 45.png"
                            style="height: 180px; width: 180px;" class="image4">
                        </div>
                    </div>
                    <div class="feed1">
                        <div class="image-3">
                            <img src="../../../../assets/images/ad_landing_page_assets/Intersection 47.png"
                                height="150px" width="150px" class="image3">

                            <img class="arr4" src="../../../../assets/images/ad_landing_page_assets/arrow3.png"
                                style="height: 60px; width: 40px;">
                        </div>
                        <div class="text-container4">
                            Unbeatable prices
                        </div>
                    </div>

                </div>
            </div>
        </div>



        <div class="ui-g-12">
            <ng-container>
                <div class="ui-g">
                    <div class="ui-lg-1"></div>
                    <div class="ui-lg-10 btm">
                        <p class="enq">Not registered on eGlobalDoctors?
                            <button class="btn1"><a
                                    href="https://portal.eglobaldoctors.com/user/register/patient">Get
                                    Started</a></button>
                        </p>
                    </div>
                    <div class="ui-lg-1"></div>
                </div>
            </ng-container>
        </div> -->